import React from 'react';
import css from './GojekRentACarLandingPage.css';
import bannerLogo from '../../assets/GojekBanner/banner-logo.svg';
import bannerLogoMobile from '../../assets/GojekBanner/banner-logo-mobile@2x.png';
import bannerBackground from '../../assets/GojekBanner/rent-banner.png';
import approveBlueIcon from '../../assets/GojekBanner/approval-symbol-in-badge-blue@2x.png';
import saveMoneyIcon from '../../assets/GojekBanner/noun_Save Money_776848@2x.png';
import easyAccessIcon from '../../assets/GojekBanner/noun_easy_3428320@2x.png';
import approveBlueIconMobile from '../../assets/GojekBanner/approval-symbol-in-badgeM@2x.png';
import saveMoneyIconMobile from '../../assets/GojekBanner/noun_Save Money_776848M@2x.png';
import easyAccessIconMobile from '../../assets/GojekBanner/noun_easy_3428320M@2x.png';
import GojekLogo from '../../assets/GojekBanner/gojek-rentals-desktop.svg';
import GojekLogoWhite from '../../assets/GojekBanner/gojek-rentals-mobile.svg';
import { IconSpinner } from '../../components';
import { useHistory, useLocation } from 'react-router-dom';
import { parse } from '../../util/urlHelpers';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { formatMoney } from '../../util/currency';
import { types } from '../../util/sdkLoader';
import config from '../../config';

const { Money } = types;

const GojekIntroBanner = ({ isScoot, signUpCodeAmount, loading, isMobileLayout }) => {
  const location = useLocation();
  const history = useHistory();
  const { code } = parse(location.search);
  const currentUser = useSelector(state => state.user.currentUser);
  const intl = useIntl();
  const redirectToSignup = () => {
    const url = createResourceLocatorString('SignupPage', routeConfiguration(), {}, {});
    history.push(
      code
        ? {
          pathname: url,
          search: `?code=${code}`,
        }
        : {
          pathname: url,
        }
    );
  };
  return (
    <div className={css.bannerIntroSection}>
      <div className={css.container}>
        <div className={css.row}>
          <div className={css.column6}>
            <div className={css.bannerIntroContent}>
              <div className={css.bannerLogoBlock}>
                {!isMobileLayout && <img src={bannerLogo} alt="Go jek logo" />}
              </div>
              <div className={css.mobileBannerLogo}>
                {isMobileLayout && <img src={bannerLogoMobile} alt="Go jek logo" />}
              </div>
              <h1>
                Driving for Gojek? <br /> Rent flexibly with Drive lah
              </h1>
              <ul className={css.bannerListing}>
                <li>
                  <span className={css.pointIcons}>
                    {isMobileLayout ? (
                      <img src={approveBlueIconMobile} alt="Right Tick Icon" />
                    ) : (
                      <img src={approveBlueIcon} alt="Approved by LTA" />
                    )}
                  </span>
                  Approved by{' '}
                  <span className={css.contentIcon}>
                    {isMobileLayout ? (
                      <img src={GojekLogoWhite} alt="Go jek logo" />
                    ) : (
                      <img src={GojekLogo} alt="Go jek logo" />
                    )}
                  </span>
                </li>
                <li>
                  <span className={css.pointIcons}>
                    {isMobileLayout ? (
                      <img src={saveMoneyIconMobile} alt="Save Money Icon" />
                    ) : (
                      <img src={saveMoneyIcon} alt="Save Money Icon" />
                    )}
                  </span>
                  From only $4/Hour or $29/Day
                </li>
                <li>
                  <span className={css.pointIcons}>
                    {isMobileLayout ? (
                      <img src={easyAccessIconMobile} alt="Easy Access Icon" />
                    ) : (
                      <img src={easyAccessIcon} alt="Easy Access Icon" />
                    )}
                  </span>
                  Pay per use, no long lease contracts
                </li>
              </ul>
              <button onClick={() => redirectToSignup()} className={css.bannerButton}>
                {loading ? (
                  <div className={css.loadingWrapper}>
                    <IconSpinner className={css.loadingSpinner} />
                  </div>
                ) : currentUser && currentUser.id ? (
                  <>
                    <div className={css.signUpTitle}>
                      {signUpCodeAmount && signUpCodeAmount > 0 ? (
                        <span>
                          Sign up now to get{' '}
                          {formatMoney(intl, new Money(signUpCodeAmount, config.currency))} credits
                        </span>
                      ) : (
                        <span>Signup to get 50% off forever</span>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className={css.signUpTitle}>
                      {signUpCodeAmount && signUpCodeAmount > 0 ? (
                        <span>
                          Sign up now to get{' '}
                          {formatMoney(intl, new Money(signUpCodeAmount, config.currency))} credits
                        </span>
                      ) : (
                        <span>Signup to get 50% off forever</span>
                      )}
                    </div>
                  </>
                )}
              </button>

            </div>
          </div>
        </div>
      </div>
      <div className={css.bannerIntroImageSection}>
        <img src={bannerBackground} alt="Flexible monthly rental hire to drive for gojek with drive lah" />
      </div>
    </div>
  );
};

export default GojekIntroBanner;
